import React, { useEffect, useMemo } from "react";
import { useFormikContext } from "formik";
import FieldUnitPopover from "views/components/aggregationwizard/units/FieldUnitPopover";
import useFieldTypesUnits from "views/hooks/useFieldTypesUnits";
import useFieldTypes from "views/logic/fieldtypes/useFieldTypes";
import { Properties } from "views/logic/fieldtypes/FieldType";
const FieldUnit = ({ field }) => {
  const fieldTypesUnits = useFieldTypesUnits();
  const { data } = useFieldTypes(void 0, void 0);
  const predefinedValue = useMemo(() => fieldTypesUnits == null ? void 0 : fieldTypesUnits[field], [field, fieldTypesUnits]);
  const { setFieldValue, values } = useFormikContext();
  const showUnitComponent = useMemo(
    () => !!(data == null ? void 0 : data.find((f) => {
      var _a, _b;
      return f.name === field && ((_b = (_a = f == null ? void 0 : f.type) == null ? void 0 : _a.properties) == null ? void 0 : _b.contains(Properties.Numeric));
    })),
    [data, field]
  );
  useEffect(() => {
    if (predefinedValue && !values.units[field]) {
      setFieldValue(`units.${field}`, { abbrev: predefinedValue.abbrev, unitType: predefinedValue.unitType });
    }
  }, [field, predefinedValue, setFieldValue, values.units]);
  if (!showUnitComponent) return null;
  return /* @__PURE__ */ React.createElement(FieldUnitPopover, { field, predefinedUnit: predefinedValue });
};
export default FieldUnit;
